import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from '@environments/environment';
import { Store, Select } from '@ngxs/store';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { Observable } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';
import { OpenSnackbarAction, SetThemeAction } from '@ngxs-store/ui-store/ui.actions';
import { UiState } from '@ngxs-store/ui-store/ui.state';
import { DecodedToken, LastLoggedInUser, SnackbarType } from '@core/models';
import { LoginAction, ClearTokenAction, ClearLastUserAction } from '@ngxs-store/auth-store/auth.actions';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Navigate } from '@ngxs/router-plugin';
import { AuthenticateUserCommand } from '@core/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  @Select(AuthState.getDecodedToken) decodedToken$: Observable<DecodedToken>;
  @Select(AuthState.getHasValidToken) hasValidToken$: Observable<boolean>;
  @Select(AuthState.getLastLoggedInUser) lastLoggedInUser$: Observable<LastLoggedInUser>;
  @Select(AuthState.getIsLoading) isLoading$: Observable<boolean>;
  @Select(UiState.getIsMobileMode) isMobileMode$: Observable<boolean>;
  @Select(UiState.getTheme) theme$: Observable<string>;

  hasRole$: Observable<boolean>;

  constructor(
    private store: Store
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const requiredRolesForRoute: string[] = route.data.roles ? route.data.roles : [];
    this.hasRole$ = this.store.select(AuthState.getHasRole).pipe(map((hasRoleFn) => hasRoleFn(requiredRolesForRoute)));

    return this.hasValidToken$.pipe(withLatestFrom(this.hasRole$),
      map(([hasValidToken, hasRole]: [boolean, boolean]) => {
        if (hasValidToken && hasRole) {
          return true;
        } else {

          if (!hasValidToken) {
            this.store.dispatch([
              new ClearLastUserAction(),
              new ClearTokenAction()
            ]);

            return true;
          }

          // // if we came here from direct link or browser refresh
          // if (state.root.component) {
          //   this.store.dispatch(
          //     new OpenSnackbarAction({
          //       message: 'Authorization denied.',
          //       type: SnackbarType.Simple
          //     })
          //   );
          // } else {
          //   this.store.dispatch(new Navigate(['/authorization-denied']));
          // }

          // return false;
        }
      })
    );
  }


  
}
